import React from "react"
import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import Button from "../../../../shared/components/atoms/button/button"
import decorationMobile from "../../../../assets/images/muestreo/decoration-mobile.svg"

const StepFour = props => {
  let {
    details,
    params,
    randomKey,
    setShowWinSample,
    setActualStep,
    ACTIVITY_ID_MUESTREO,
  } = props

  return (
    <div className="container">
      {!["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
        <div className="decoration-left rounded-top-left-no-mov hidden-mov-large background-color-primary" />
      ) : null}
      {!["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
        <div className="decoration-top-mov background-color-primary" />
      ) : null}
      <div
        className={
          "details rounded-top-no-mov activity-modal-style " +
          (["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO)
            ? "muestra-gratis-antibacterial container-step-background"
            : "muestreo-normal muestreo-normal-container")
        }
      >
        {(details = []) &&
        documentToReactComponents(params.contenidoFinalizarMuestreo.json, {
          renderNode: {
            [BLOCKS.HEADING_1]: (node, children) => {
              details.push(
                <h1
                  key={randomKey}
                  className={
                    "text-color-secondary " +
                    (ACTIVITY_ID_MUESTREO == "48"
                      ? "title-muestreo-special"
                      : "title-muestreo-normal")
                  }
                >
                  {children}
                </h1>,
              )
            },
            [BLOCKS.PARAGRAPH]: (node, children) => {
              details.push(
                <p
                  className={
                    ACTIVITY_ID_MUESTREO != "91" ||
                    ACTIVITY_ID_MUESTREO != "92"
                      ? ["141","192","193"].includes(ACTIVITY_ID_MUESTREO) ? "text-color-sixty" : "text-color-sixty"
                      : ""
                  }
                  key={randomKey}
                >
                  {children}
                </p>,
              )
            },
            [BLOCKS.EMBEDDED_ASSET]: node => {
              return (
                <img
                  key={randomKey}
                  className={
                    "image-step-five " +
                    (ACTIVITY_ID_MUESTREO == "48"
                      ? "image-muestreo-special"
                      : "")
                  }
                  src={node.data.target.fields.file[process.env.LOCALE].url}
                />
              )
            },
          },
        })}
        <div
          className={
            "details-step-five " +
            (ACTIVITY_ID_MUESTREO == "48"
              ? "muestreo-special-container"
              : "muestreo-normal-container")
          }
        >
          {details}
          <div className="buttons">
            <Button
              title="Volver al producto"
              className={`button ${(["141"].includes(ACTIVITY_ID_MUESTREO)) ? "background-color-quaternary" : "background-color-secondary"}`}
              onClick={e => {
                e.preventDefault()
                setShowWinSample(false)
              }}
            />
            {/*{(!["141"].includes(ACTIVITY_ID_MUESTREO)) && (*/}
              <Button

                title="Participar otra vez"
                className={`button ${(["141"].includes(ACTIVITY_ID_MUESTREO)) ? "background-color-quaternary" : "background-color-primary-button"} `}
                onClick={e => {
                  e.preventDefault()
                  setActualStep(1)
                }}
              />

            {/*)}*/}

          </div>
        </div>
      </div>
      {!["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
        <div className="decoration-right rounded-top-right-no-mov hidden-mov-large background-color-primary" />
      ) : null}
    </div>
  )
}

export default StepFour
